module.exports = __webpack_public_path__ + "assets/images/slope-income/desktop.svg?v=8aa33c6a";